import { useXYChartData } from './useXYChartData.js';

export function useXYChartCrosshairHidden() {
  const { axes } = useXYChartData();
  return {
    hideHorizontal:
      !axes.some((axis) => axis.coordinate === 'y') ||
      axes.some(
        (axis) => axis.coordinate === 'y' && axis.hideCrosshair === true,
      ),
    hideVertical:
      !axes.some((axis) => axis.coordinate === 'x') ||
      axes.some(
        (axis) => axis.coordinate === 'x' && axis.hideCrosshair === true,
      ),
  };
}
